import { AvailabilityRule, DateWithSingleRangeValue, PeriodRange } from "PFTypes";

const isObject = (value: any): value is object => typeof value === "object";

export const isAvailabilityRule = (value: any): value is AvailabilityRule =>
  value &&
  isObject(value) &&
  "mode" in value &&
  "ranges" in value &&
  ("availability_threshold" in value || "availabilityThreshold" in value);

export const isDateWithSingleRangeValue = (value: any): value is DateWithSingleRangeValue | PeriodRange =>
  value && isObject(value) && "start" in value && "end" in value;
